/**
 * Modelo de objeto de Button;
 * @class InputButtonConfig
 * @namespace InputButtonConfig
 */
 export class InputButtonConfig {
    /**
     * Objeto de configuração base para um input de texto
     * @param {String} id - Id do input
     * @param {String} name - Name para configurações e referencias
     * @param {String} label - Texto a ser exibido na label
     * @param {Boolean} required - Boolean indicando se campo é obrigatório
     * @param {String} value - Valor Padrão (só utilizado na inicialização)
     * @param {Function} callbackFn - Função a ser executada no callback de mudança de valor
     * @param {Boolean} disabled - Boolean indicando se campo esta desabilitado
     */
    constructor(id, name, nome, cor = 'is-primary', callbackFn = () => {}, validationFn = null, disabled) {
      this.id = id;
      this.name = name;
      this.nome = nome;
      this.cor = cor;
      this.callbackFn = callbackFn;
      this.validationFn = validationFn;
      this.disabled = disabled;
    }

  }